import { History } from 'history'
import { Middleware } from 'redux'

import { selectQueryState, selectQueryString } from '~/app/store/locationState/reducer'
import { getGalleryContextFromQueryString } from 'shared/url'
import { history as galleryHistory } from '~/app/utils/history'
import { stateFromQueryStateUpdate } from '~/app/store/locationState/actions'
import type { State } from 'shared/types/gallery/state'

/* eslint-disable @typescript-eslint/no-explicit-any */
//TODO MIGRATION T011: Fix eslint errors

/**
 * Redux dispatch middleware that updates the current location when
 * (and only when) state is changed. If no `history` exists (i.e. on the
 * server-side), this middleware is skipped.
 * @param rules
 */
export const stateToLocation =
  (history: History | null): Middleware =>
  ({ getState }) =>
  (next) =>
  (action: any): any => {
    // Only update the url if the action specifically indicates to do so
    if (!history || !action.meta || !action.meta.updateUrl) {
      return next(action)
    }

    const result = next(action)
    const newState = getState()
    const newQueryState = selectQueryState(newState)
    const queryString = selectQueryString(newQueryState, window.location.search)

    if (queryString !== window.location.search) {
      // passing an empty string to push/replace will remove the path
      history.push(queryString || '?')
    }

    return result
  }

export const locationToState = (dispatch: State.GalleryThunkDispatch, isNewQVEnabled: boolean): void => {
  if (!galleryHistory) {
    return
  }

  let previousQueryString = galleryHistory.location.search

  galleryHistory.listen(({ location, action }) => {
    if (action === 'POP' && location.search !== previousQueryString) {
      const queryState = getGalleryContextFromQueryString(location.search)
      const prevQueryString = getGalleryContextFromQueryString(previousQueryString)

      dispatch(stateFromQueryStateUpdate(queryState, prevQueryString, isNewQVEnabled))
    }

    const hasQuickViewInParams = location.pathname.includes('/qv/') || location.search.includes('qv=')
    if (action === 'POP' && !hasQuickViewInParams) {
      window.scrollTo(0, 0)
    }

    previousQueryString = location.search
  })
}
